import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/compras/compras';
import Saldos from './SaldosList';


const ms2p = (state) => {
  return {
    ...state.compra,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Saldos);
